import parser from "odata-parser";

export default {
	name: "jsonUtil",
	methods: {

		// Input: object { filter: string, limit: number }, filter string is in OData format: e.g. "Id eq 1 and Title eq 'test a'"
		// Action: convert Odata format to json-server format: e.g. "Id=1&Title='test a'"
		// Return: a string
		// Limitation: convert all operators to equal, can only take 2 or less filters
		_getLocalRequest(queryObject) {

			let queryOData = `$filter=${queryObject.filter}&$top=${queryObject.limit}`;
			let queryJSON = parser.parse(queryOData);

			let queryString = (queryJSON.left) ? `?${queryJSON.left.name}=${queryJSON.right.value}` :
				(queryJSON.$filter && queryJSON.$filter.left.name) ? `?${queryJSON.$filter.left.name}=${queryJSON.$filter.right.value}` :
				(queryJSON.$filter && queryJSON.$filter.left.left.name) ? `?${queryJSON.$filter.left.left.name}=${queryJSON.$filter.left.right.value}&${queryJSON.$filter.right.left.name}=${queryJSON.$filter.right.right.value}` :
				"";

			// queryString = (queryString.search("/") !== -1) ? queryString.replace(/\//g, ".") : queryString;
			queryString = (queryString.search("/") !== -1) ? queryString.replace(/\//g, "") : queryString;

			queryString += (queryJSON.$top & queryString.length === 0) ? `_limit=${queryJSON.$top}` :
				(queryJSON.$top & queryString.length !== 0) ? `&_limit=${queryJSON.$top}` :
				"";

			return queryString;
		},

		_QueryStringToJSON(queryObject) {

			if (queryObject) {

				if (queryObject.batchQuery && queryObject.batchQuery==true) {

					return queryObject.filter;
				}
				let queryString = this._getLocalRequest(queryObject).slice(1).split('&');

				let result = {};
				queryString.forEach(function (pair) {
					pair = pair.split('=');
					result[pair[0]] = decodeURIComponent(pair[1] || '');
				});

				for(let prop in result){
					if(result.hasOwnProperty(prop) && result[prop] !== null && !isNaN(result[prop])){
						result[prop] = +result[prop];   
					}
				}			
				
				return result;
			}
		}
	}
}